<!-- Header: classification + freshness + on-demand refresh (RF-15) -->
<div class="health-dash__header">
  <div class="health-dash__status">
    <span class="badge campaign-badge" [ngClass]="badgeClass()">{{ badgeLabel() }}</span>
    @if (freshnessLabel()) {
      <span class="health-dash__freshness">{{ freshnessLabel() }}</span>
    }
  </div>
  <button type="button" class="btn btn-outline-primary" (click)="refreshNow()" [disabled]="refreshing">
    @if (!refreshing) {
      <i class="ri-refresh-line"></i>
      {{ 'channel.health.dash.refreshNow' | translate }}
    } @else {
      <mat-spinner [diameter]="20" mode="indeterminate" />
    }
  </button>
</div>

<!-- Sub-areas (RF-16); profile admin-only (RF-36) -->
<ul class="nav nav-pills health-dash__tabs mb-3">
  <li class="nav-item">
    <a class="nav-link" [class.active]="activeTab === 'resumo'" href="javascript:void(0)" (click)="activate('resumo')">
      {{ 'channel.health.dash.tabSummary' | translate }}
    </a>
  </li>
  <li class="nav-item">
    <a class="nav-link" [class.active]="activeTab === 'saude'" href="javascript:void(0)" (click)="activate('saude')">
      {{ 'channel.health.dash.tabHealth' | translate }}
    </a>
  </li>
  <li class="nav-item">
    <a class="nav-link" [class.active]="activeTab === 'qualidade'" href="javascript:void(0)" (click)="activate('qualidade')">
      {{ 'channel.health.dash.tabQuality' | translate }}
    </a>
  </li>
  @if (channel?.hybrid) {
    <li class="nav-item">
      <a class="nav-link" [class.active]="activeTab === 'hibrido'" href="javascript:void(0)" (click)="activate('hibrido')">
        <i class="ri-git-branch-line me-1"></i>{{ 'channel.health.dash.tabHybrid' | translate }}
      </a>
    </li>
  }
  @if (canSeeProfile()) {
    <li class="nav-item">
      <a class="nav-link" [class.active]="activeTab === 'perfil'" href="javascript:void(0)" (click)="activate('perfil')">
        {{ 'channel.health.dash.tabProfile' | translate }}
      </a>
    </li>
  }
</ul>

@if (activeTab === 'resumo') {
  <health-summary-tab [channel]="channel" [refreshTick]="refreshTick" (goToHealth)="activate('saude')" />
}
@if (activeTab === 'saude') {
  <health-status-tab [channel]="channel" [health]="health" [pendingIssues]="pendingIssues" [events]="events" [refreshTick]="refreshTick" />
}
@if (activeTab === 'qualidade') {
  <health-quality-tab [channel]="channel" [refreshTick]="refreshTick" />
}
@if (activeTab === 'hibrido' && channel?.hybrid) {
  <!-- Session pairing and the official share (SPEC-2026-10-whatsapp-hybrid-channel T-27 / T-28) -->
  <channel-hybrid-session-component [channel]="channel" (channelChange)="channel = $event" />
}
@if (activeTab === 'perfil' && canSeeProfile()) {
  <health-profile-tab [channel]="channel" [refreshTick]="refreshTick" />
}

<!-- Channel actions — same footer as the old dashboard (channel-config), visible on every tab.
     A channel not yet connected gets the Embedded Signup CONNECT button, exactly as before. -->
@if (channel) {
  <hr class="mt-4" />
  <div class="row mt-4">
    <div class="col-12 gap-2 d-flex justify-content-end pb-4 align-items-baseline">
      <button
        class="btn btn-outline-danger"
        (click)="onDelete(channel)"
      >
        {{ 'channel.channelConfig.remove' | translate }}
      </button>

      @if (channel.connected) {
        <button
          class="btn"
          [ngClass]="actionLoading ? 'btn-outline-primary' : 'btn-danger'"
          (click)="disconnect()"
          [disabled]="actionLoading"
        >
          @if (!actionLoading) {
            <i class="ri-plug-line"></i>
            {{ 'channel.channelConfig.disconnect' | translate }}
          } @else {
            <mat-spinner [diameter]="20" mode="indeterminate" />
          }
        </button>

        <app-whatsapp-signup
          [nameChannel]="channel.name"
          [idChannel]="channel._id"
          [creditLine]="!!channel.creditLine" [hybrid]="!!channel.hybrid"
          [labelKey]="'whatsappSignup.home.reconnectButton'"
          [buttonClass]="'btn btn-outline-primary'"
          [disabledButton]="actionLoading"
          (onSave)="onEmbeddedConnected($event)"
        />
      } @else {
        <app-whatsapp-signup
          [nameChannel]="channel.name"
          [idChannel]="channel._id"
          [creditLine]="!!channel.creditLine" [hybrid]="!!channel.hybrid"
          [buttonClass]="'btn btn-primary'"
          (onSave)="onEmbeddedConnected($event)"
        />
      }

      <button
        class="btn btn-success"
        (click)="edit(channel)"
      >
        {{ 'channel.channelConfig.edit' | translate }}
      </button>
    </div>
  </div>
}
